/**
 * Returns YouTube ID from a YouTube URL
 * @param {string} url a URL with a YouTube ID in it
 * @returns {string} id of youtube video
 */
const getYouTubeIdFromUrl = (url) => {
  let ID = '';
  const parsedUrl = url
    .replace(/(>|<)/gi, '')
    .split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);

  if (parsedUrl[2] !== undefined) {
    [ID] = parsedUrl[2].split(/[^0-9a-z_-]/i);
  } else {
    ID = parsedUrl;
  }

  return Array.isArray(ID) ? ID[0] : ID;
};

export default getYouTubeIdFromUrl;
